
export default {
  SET_FORECAST_DATA(state, payload) {
    state.forecastData = payload;
  },
  CLEAR_FORECAST_DATA(state) {
    state.forecastData = {};
  },
}
